import { render, staticRenderFns } from "./inquiryDialog.vue?vue&type=template&id=2c1b3bf8&scoped=true"
import script from "./inquiryDialog.vue?vue&type=script&lang=js"
export * from "./inquiryDialog.vue?vue&type=script&lang=js"
import style0 from "./inquiryDialog.vue?vue&type=style&index=0&id=2c1b3bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b3bf8",
  null
  
)

export default component.exports